import React from 'react';
import { Input, Select, Radio, Checkbox, Row, Col, DatePicker, Icon } from 'antd';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import moment from 'moment';
const { Option } = Select;
const InputGroup = Input.Group;

export default class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16} align="middle">
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value, null)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value, null)}
                        />
                    </Col>


                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idEstablecimiento ? { key: this.props.filter.idEstablecimiento } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Establecimiento" />}
                            onChange={(option) => this.props.onChange("idEstablecimiento", option.key, option.label)}
                            optionFilterProp="children"
                        >
                            <Option key={'0'} value={'0'}>
                                <span>TODOS</span>
                            </Option>
                            {this.props.establecimientos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    {this.props.filter.tipoReporte == 1 ?
                        null :
                        <>
                            <Col className="gutter-row" sm={24} md={12} lg={4} hidden={this.props.filter.tipoReporte == 2}>
                                <Select
                                    showSearch labelInValue
                                    value={this.props.filter.idAlmacen ? { key: this.props.filter.idAlmacen } : undefined}
                                    placeholder={<SelectPlaceHolder label="Filtrar por almacén" />}
                                    onChange={(option) => this.props.onChange("idAlmacen", option.key, option.label)}
                                    optionFilterProp="children"
                                    loading={this.props.monedasLoading}
                                >
                                    <Option key={'0'} value={'0'}>
                                        <span>TODOS</span>
                                    </Option>
                                    {this.props.almacenes.map(item => (
                                        <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                                    ))}
                                </Select>
                            </Col>

                            <Col className="gutter-row" sm={24} md={12} lg={6}>
                                <Select showSearch labelInValue
                                    value={this.props.filter.idTipoProducto ? { key: this.props.filter.idTipoProducto } : undefined}
                                    placeholder={<SelectPlaceHolder label="Filtrar por Tipo Producto" />}
                                    onChange={(option) => {
                                        //this.props.form.setFieldsValue({ idProducto: undefined });
                                        this.props.onChange("idTipoProducto", option.key, option.label)
                                    }}
                                    optionFilterProp="children"
                                >
                                    {this.props.tipoProductos.map(item => (
                                        <Select.Option key={item.id}>{item.nombre}</Select.Option>
                                    ))}
                                </Select>
                            </Col>

                            <Col className="gutter-row" sm={24} md={12} lg={6}>
                                <Select showSearch labelInValue
                                    value={this.props.filter.idProducto ? { key: this.props.filter.idProducto } : undefined}
                                    placeholder={<SelectPlaceHolder label="Filtrar por Producto" />}
                                    onChange={(option) => this.props.onChange("idProducto", option.key, option.label)}
                                    optionFilterProp="children"
                                >
                                    <Option key={'0'} value={'0'}>
                                        <span>TODOS</span>
                                    </Option>
                                    {this.props.productos.map(item => (
                                        <Select.Option key={item.id}>{item.nombre}</Select.Option>
                                    ))}
                                </Select>
                            </Col>

                            <Col className="gutter-row" sm={24} md={12} lg={6}>
                                <Input
                                    prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    value={this.props.filter.referencia}
                                    onChange={(e) => this.props.onChange("referencia", e.target.value, null)}
                                    placeholder="Filtrar por codigo referencia"
                                    autoComplete="off"
                                />
                            </Col>

                        </>
                    }
                    {this.props.filter.tipoReporte == 4 ?

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={this.props.filter.idVendedor ? { key: this.props.filter.idVendedor } : undefined}
                                placeholder={<SelectPlaceHolder label="Filtrar por Vendedor" />}
                                onChange={(option) => this.props.onChange("idVendedor", option.key, option.label)}
                                optionFilterProp="children"
                            >
                                <Option key={'0'} value={'0'}>
                                    <span>TODOS</span>
                                </Option>
                                {this.props.vendedores.map(item => (
                                    <Select.Option value={item.id} key={item.id}>{item.razonSocialEntidad}</Select.Option>
                                ))}
                            </Select>
                        </Col>
                        : null
                    }
                    <Col className="gutter-row" sm={24} md={24} lg={3}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'right' }} >
                            <Checkbox
                                defaultChecked={this.props.filter.flagNotaVenta}
                                onChange={(e) => this.props.onChange("flagNotaVenta", e.target.checked)}
                                value={this.props.filter.flagNotaVenta}
                                checked={this.props.filter.flagNotaVenta}
                            >Incluir Nota de Venta</Checkbox>
                        </div>
                    </Col>

                    <Col className="gutter-row" sm={24} md={24} lg={8}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>Establecimiento</Radio>
                                <Radio value={2}>Producto</Radio>
                                <Radio value={4}>Vendedor</Radio>
                                <Radio value={3}>Detallado</Radio>

                            </Radio.Group>
                        </div>
                    </Col>
                    <Col className="gutter-row" sm={24} md={24} lg={2}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'right' }} >
                            <Checkbox
                                defaultChecked={this.props.filter.flagIGV}
                                onChange={(e) => this.props.onChange("flagIGV", e.target.checked)}
                                value={this.props.filter.flagIGV}
                                checked={this.props.filter.flagIGV}
                            >Incluir IGV</Checkbox>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}